import { Skeleton } from "../../../../components/atoms/Skeleton";

export function SkeletonLineChart({ height = "400px"}) {
  return (
    <section
      style={{
        width: "100%",
        display: "grid",
        gridTemplateColumns: "130px 1fr",
        gap: "10px",
        marginBlockStart: "40px"
      }}>
      <section
        style={{
          display: "grid",
          gridTemplateRows: "auto",
          justifyContent: "flex-end",
          marginBlockStart: "10px"
        }}>
        {Array.from({ length: 12 }, (_, i) => (
          <Skeleton
            style={{
              width: `${Math.max(100, Math.random() * 150)}px`,
              height: "10px",
              marginInlineStart: "auto"
            }}
            key={i}
          />
        ))}
      </section>
      <section>
        <Skeleton style={{ width: "100%", height }} />
      </section>
    </section>
  );
}
